export function shouldFetchSelectedCustomVoice({
  selectedVoiceId,
  customVoiceMap,
  libraryVoiceMap,
}: {
  selectedVoiceId: string;
  customVoiceMap: Record<string, unknown>;
  libraryVoiceMap: Record<string, unknown>;
}) {
  return !!selectedVoiceId && !libraryVoiceMap[selectedVoiceId] && !customVoiceMap[selectedVoiceId];
}
